// ** Cache clearing utilities
// ** Shared logic for clearing all browser caches and storage

/**
 * Comprehensive cache clearing function
 * This function clears all browser storage and cache
 * Used during logout and refresh token expiry
 */
export const clearAllCache = async () => {
  try {
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    // Clear all cookies
    document.cookie.split(";").forEach(function (c) {
      document.cookie = `${c.replace(/^ +/, "").replace(/=.*/, "")}=;expires=${new Date().toUTCString()};path=/`;
    });

    // Clear browser cache (if supported)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    }

    console.log('All cache cleared successfully');
  } catch (error) {
    console.error('Error during cache clearing:', error);
    throw error;
  }
};

/**
 * Clear cache and reload page
 * Used when we want to completely reset the application state
 */
export const clearCacheAndReload = async () => {
  try {
    await clearAllCache();
    // Force a hard refresh of the application
    window.location.reload(true);
  } catch (error) {
    console.error('Error during cache clearing and reload:', error);
    // Even if cache clearing fails, try to reload
    window.location.reload(true);
  }
};
